import Marquee from "react-fast-marquee";

const ITEMS = [
  "On-Site Training at Your Stables",
  "Exclusively for Women Horse Owners",
  "October — May",
  "All Breeds · All Ages",
  "Dubai",
];

const EditorialMarquee = () => (
  <div
    data-testid="editorial-marquee"
    className="border-y border-champagne/10 bg-ebony py-7"
  >
    <Marquee speed={35} gradient={false} pauseOnHover>
      {ITEMS.map((item, i) => (
        <div key={i} className="flex items-center">
          <span className="px-10 font-serif text-xl italic tracking-wide text-champagne/80 md:text-2xl">
            {item}
          </span>
          <span className="h-1.5 w-1.5 rotate-45 bg-gold/50" />
        </div>
      ))}
    </Marquee>
  </div>
);

export default EditorialMarquee;
